"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
/**
 * Wrapper component to load on demand components.
 * Used as a placeholder for lazy loading components.
 * Renders `null` until the component has loaded.
 *
 * @class ComponentOnDemand
 * @extends {Component<any, any>}
 */
var ComponentOnDemand = /** @class */ (function (_super) {
    tslib_1.__extends(ComponentOnDemand, _super);
    function ComponentOnDemand(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onComponentLoaded = function (OnDemandComponent) {
            _this.WrappedComponent = OnDemandComponent;
            _this.setState({ compLoaded: true });
        };
        _this.WrappedComponent = null;
        _this.state = { compLoaded: false };
        _this.initialize();
        return _this;
    }
    ComponentOnDemand.prototype.initialize = function () {
        this.props.loadComponent(this.onComponentLoaded);
    };
    ComponentOnDemand.prototype.render = function () {
        var compLoaded = this.state.compLoaded;
        var WrappedComponent = this.WrappedComponent;
        var _a = this.props, loadComponent = _a.loadComponent, props = tslib_1.__rest(_a, ["loadComponent"]);
        return compLoaded ? React.createElement(WrappedComponent, tslib_1.__assign({}, props)) : null;
    };
    return ComponentOnDemand;
}(React.Component));
/**
 * * Gets a loader function which will `require.ensure(...)`
 * a component
 *
 * @export
 * @param {(callback: Function) => void} loaderFn
 * @returns {Function} Component
 *
 * How to use:
 * ----------
 * import componentOnDemend from 'ui/compositions'
 *
 * export default componentOnDemand((callback) => require.ensure(['$COMPONENT_PATH'], (require) => {
 *
 *   let Comp = require('$COMPONENT_PATH') as any;
 *
 *   callback(Comp.default);
 *
 * }, "$CHUNK_NAME"));
 */
function default_1(loaderFn) {
    return function (props) { return React.createElement(ComponentOnDemand, tslib_1.__assign({ loadComponent: loaderFn }, props)); };
}
exports.default = default_1;
